export default {
  "breadcrumbs.home": "HOME",
  "breadcrumbs.event": "イベント一覧",
  "breadcrumbs.bbt.event": "イベント・プログラム一覧",
  "breadcrumbs.event.archive": "過去イベント",
  "breadcrumbs.login": "マイページ",
  "breadcrumbs.signup": "新規登録",
  "breadcrumbs.usage": "ご利用規約・掲載について",

  "breadcrumbs.interview": "インタビュー・コラム一覧",
  "breadcrumbs.bulletinboard": "人と情報の交流掲示板一覧",
  "breadcrumbs.news": "ニュース一覧",

  "breadcrumbs.register": "同意事項",
  "breadcrumbs.register.form": "投稿アカウント新規登録",
  "breadcrumbs.register.form_check": "投稿アカウント新規登録",
  "breadcrumbs.register.complete": "投稿アカウント新規登録",

  "breadcrumbs.about": "LINK-Jを知る",
  "breadcrumbs.about.introduction-corporate": "特別会員一覧", // same as URL structure
  "breadcrumbs.contact": "同意事項",
  "breadcrumbs.contact.form": "問い合わせフォーム",
  "breadcrumbs.contact.confirm": "問い合わせフォーム",
  "breadcrumbs.contact.complete": "問い合わせフォーム",

  "breadcrumbs.report": "イベントレポート一覧",
  "breadcrumbs.bbt.report": "レポート一覧",

  "breadcrumbs.sandbox": "SANDBOX一覧",
} as const;
